import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import {
    fetchAddTipo_estado,
    fetchEditTipo_estado,
    fetchGetTipo_estadoList,
    setFilters,
    returnFetchDeleteTipo_estado,
    setLogError,
    setPage,
    setItemsPerPage
} from "../../reducers/tipo_estadoSlice";

import {
    Tipo_estadoColumnList,
    Tipo_estadoFilterValidationSchema,
    Tipo_estadoValidationSchema
} from "./Tipo_estadoConstants";
import GenericModule from "../../components/GenericModule";


function Tipo_estadoList(props) {

    const moduleData = useSelector((state) => state.tipo_estado);
    const logguedUserData = useSelector(state => state.common.logguedUserData);

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const emptyNew = {};;

    useEffect(() => {
        dispatch(fetchGetTipo_estadoList({ page: 0, pageCount: 0, rowsPerPage: moduleData.itemsPerPage }));
    }, []);

    const refreshData = (filters) => {
        dispatch(fetchGetTipo_estadoList({ ...filters }));
    }

    const editData = (data) => {
        return Promise.all([
            dispatch(fetchEditTipo_estado(data)),
        ]);
    }

    const insertData = (data) => {
        return Promise.all([
            dispatch(fetchAddTipo_estado(data)),
        ]);
    }

    const updateFilters = (filters) => {
        dispatch(setFilters(filters));
    }

    const deleteData = async (id) => {
        const response = await returnFetchDeleteTipo_estado(id);
        return response;
    }

    const clearLogError = () => {
        dispatch(setLogError(null));
    }

    const handleSetPage = (page) => {
        dispatch(setPage(page));
    }

    const handleSetItemsPerPage = (ipp) => {
        dispatch(setItemsPerPage(ipp));
    }

    return (
        <GenericModule
            module={"tipo_estado"}
            validationSchema={Tipo_estadoValidationSchema(t)}
            filterValidationSchema={Tipo_estadoFilterValidationSchema(t)}
            columnList={Tipo_estadoColumnList(logguedUserData.isAdmin)}
            emptyNew={emptyNew}
            setFilters={updateFilters}
            dataList={moduleData.tipo_estadoList}
            moduleData={moduleData}
            refreshData={refreshData}
            editData={editData}
            insertData={insertData}
            deleteData={deleteData}
            clearLogError={clearLogError}
            setPage={handleSetPage}
            setItemsPerPage={handleSetItemsPerPage}
        />
    );
}

export default Tipo_estadoList;
